import { deleteAppSubModule } from "../api/appModuleService";

export const useDeleteSubModule = (successCallback) => {
    const remove = async (id) => {
        try {
          await deleteAppSubModule(id);
          if (successCallback) successCallback();
        } catch (error) {
            console.error("Failed to delete app sub module:", error);
            throw error;
        }
    };

    return { remove };
};